import cn from 'classnames';
import React, { useState } from 'react';

import SearchConversation from './SearchConversation';
import ConversationList from './ConversationList';
import AssignFilter from './AssignFilter';
import useConversationList from './useConversationList';
import useAssignFilter from './useAssignFilter';
import useSearchConversation from './useSearchConversation';
import ConversationsStatusSwitch from './ConversationsStatusSwitch';
import useConversationsStatusSwitch from './useConversationsStatusSwitch';

import styles from './ConversationsBar.scss';

export default function ConversationsBar() {
    const [isFaded, setIsFaded] = useState(false);

    const conversationListState = useConversationList();
    const filterState = useAssignFilter();
    const searchState = useSearchConversation();
    const statusState = useConversationsStatusSwitch();

    return (
        <div className={cn(styles.root, { [styles.faded]: isFaded })}>
            <header className={styles.header}>
                <AssignFilter onToggle={setIsFaded} {...filterState} />
                <SearchConversation className={styles.searchBlock} {...searchState} />
                <ConversationsStatusSwitch {...statusState} />
            </header>
            <ConversationList {...conversationListState} />
        </div>
    );
}
